import api from '../../../App/socket';
import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';

export const searchBikesByFilters = (params) => api.send({
    api: 'module',
    module: 'Stock',
    classMethod: 'SearchBikes',
    options: {
        where: params.filters,
        method: params.method,
        skip: params.skip,
        limit: params.limit,
    },
}).then((response) => response).catch((error) => error);

export const searchBikeBrand = async (value) => {
    try {
        const res = await leadsServiceApi({
            method: 'get',
            url: `${PURCHASING_API.BIKE_BRANDS}?filterByName=${value}&limit=10`,
        });
        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            msg: e.message,
            error: e,
        };
    }
};

export const searchBikeModel = (value, brand_id) => {
    return api.send({
        api: 'db',
        model: 'Bike_model',
        action: 'Read',
        options: {
            attributes: ['name', 'alternative_names', 'ref_bike_brand', 'wwym_priority', 'leadomatic_priority', 'mileage_limit', 'min_age', 'we_dont_want', 'cc', 'model_variation'],
            limit: 10,
            include: [
                {
                    model: 'Bike_brand',
                    attributes: 'all',
                },
            ],
            where: {
                $or: [
                    {
                        name: {
                            $regex: value,
                            $options: 'i',
                        },
                    },
                    {
                        alternative_names: {
                            $regex: value,
                            $options: 'i',
                        },
                    },
                ],
                ref_bike_brand: brand_id,
            },
            order: {
                name: 'asc',
            },
        },
    })
        .then((response) => response)
        .catch((error) => error);
};



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/requests/search_bikes_by_params.js